import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import useSEO from '../hooks/useSEO';
import { getProducts } from '../lib/cms';
import ProductCard from '../components/ProductCard';
import FrogCard from '../components/FrogCard';

const cookieVariants = [
  {
    id: 'cookie-saltkaramel-moerk',
    title: 'Mørk chokolade, Dulche striber & saltkaramel',
    tag: 'Klassiker',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/saltkaramel.jpg'],
    description: 'En uimodståelig kombination af intens mørk chokolade, toppet med cremede striber af Dulche-chokolade og et strejf af lækker saltkaramel.'
  },
  {
    id: 'cookie-dulche-salt',
    title: 'Dulche chokolade, mørke striber & saltkaramel',
    tag: 'Klassiker',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/dulche-salt.jpg'],
    description: 'Cremet, karamelliseret Dulche-chokolade dekoreret med elegante mørke chokoladestriber og fyldt med vores lækre, hjemmelavede saltkaramel.'
  },
  {
    id: 'cookie-bueno',
    title: 'Lys chokolade, mørke striber & lys hasselnødcreme (Kinder Bueno-inspireret)',
    tag: 'Kinder Bueno-inspireret',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/bueno1.jpg'],
    description: 'Lys chokolade dekoreret med mørke striber og fyldt med en silkeblød, aromatisk lys hasselnødcreme.'
  },
  {
    id: 'cookie-citron',
    title: 'Citron Kukie',
    tag: 'Frisk & Syrlig',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/citron-1.jpg'],
    description: 'En frisk og sommerlig Kukie med hvid chokolade og en syrlig, cremet citronfyld.'
  },
  {
    id: 'cookie-klassisk-knapper',
    title: 'Lys chokolade & chokoladeknapper',
    tag: 'Klassiker',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1.png'],
    description: 'Den helt klassiske og elskede Kukie-variant fyldt med masser af lækre, sprøde chokoladeknapper.'
  },
  {
    id: 'cookie-mors-dag',
    title: 'Mors Dag Kukie',
    tag: 'Sæsonvariant',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/mors-dag.jpg'],
    description: 'En kærlig hilsen til mor. Vores særlige Mors Dag Kukie er pyntet smukt med hjerter og fyldt med søde sager.'
  },
  {
    id: 'cookie-valentine',
    title: 'Valentine Kukie',
    tag: 'Sæsonvariant',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/valentine-kvadrat-format-1.jpg'],
    description: 'Den perfekte kærlighedserklæring. Sød, romantisk og uimodståelig Kukie pyntet til Valentinsdag.'
  },
  {
    id: 'cookie-nytaar',
    title: 'Nytår 2025 Kukie',
    tag: 'Sæsonvariant',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/nyta-r-25.jpg'],
    description: 'Fejr nytåret med manér! En festlig og eksklusiv Kukie pyntet med guldstøv og nytårsmotiver.'
  },
  {
    id: 'cookie-zombie',
    title: 'Thy Zombie Kukie',
    tag: 'Sæsonvariant',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thy-zombie-kukie-1.jpg'],
    description: 'Uhyggelig lækker! Vores populære Halloween-Kukie med sjove og "skræmmende" detaljer.'
  },
  {
    id: 'cookie-sommer-citron',
    title: 'Sommer Citron Kukie',
    tag: 'Sæsonvariant',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/sommer-citron.jpg'],
    description: 'En frisk og let Kukie med masser af citronsmag, perfekt til de varme sommerdage.'
  },
  {
    id: 'cookie-lakrids',
    title: 'Lakrids chokolade, lakridsdrys & lakridskaramel',
    tag: 'Klassiker',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1.png'],
    description: 'Til lakridselskeren: Lækker chokolade med et strejf af lakrids, toppet med aromatisk lakridsdrys og fyldt med flydende lakridskaramel.'
  },
  {
    id: 'cookie-hvid-hindbaer',
    title: 'Hvid chokolade, tivolikrymmel & hindbærfyld',
    tag: 'Klassiker',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1.png'],
    description: 'Sød hvid chokolade i perfekt harmoni med et friskt, syrligt hindbærfyld, festligt pyntet med farverigt tivolikrymmel.'
  },
  {
    id: 'cookie-kinder-vanilje',
    title: 'Lys chokolade, lyse striber & vaniljecreme',
    tag: 'Kinder-inspireret',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1.png'],
    description: 'En uimodståelig, blød lys chokolade med lyse striber og en cremet, fyldig vaniljecreme indeni.'
  },
  {
    id: 'cookie-skildpadde',
    title: 'Mørk chokolade & romkaramel',
    tag: 'Skildpadde-inspireret',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1.png'],
    description: 'Intens mørk chokolade kombineret med en fyldig, aromatisk romkaramel, der leder tankerne hen på den klassiske skildpadde.'
  },
  {
    id: 'cookie-dumle',
    title: 'Mørk chokolade, karamelchokolade & karamelfyld',
    tag: 'Dumle-inspireret',
    images: ['https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1.png'],
    description: 'Mørk chokolade og lækker karamelchokolade i skøn forening, fyldt med en uimodståelig, blød karamelmidte.'
  }
];

export default function Produkter() {
  const { category } = useParams();

  const categories = [
    {
      slug: 'chokolade',
      name: 'Chokolade',
      title: 'Håndlavet Chokolade',
      desc: 'Vores store udvalg af håndlavet chokolade, herunder chokoladeplader, chokoladeposer, vores populære chokoladefrøer, tørret mango med chokolade og fyldte chokolader.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/fyldte-stykker-jordba-r.jpg'
    },
    {
      slug: 'thy-kukies',
      name: 'Thy Kukies',
      title: 'Store, Lækre Thy Kukies',
      desc: 'Store, lækre Thy Kukies med masser af chokolade, bagt med fokus på det gode håndværk.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/dulche-nutella.jpg'
    },
    {
      slug: 'kager',
      name: 'Kager',
      title: 'Lækre Kager',
      desc: 'Lækre kager bagt med omhu og råvarer af højeste kvalitet.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/jordba-r.jpg'
    },
    {
      slug: 'gaveaesker-gavekurve',
      name: 'Gaveæsker & Gavekurve',
      title: 'Gaveæsker & Gavekurve',
      desc: 'Vi laver gaveæsker og gavekurve til private og erhverv i alle størrelser og sammensætninger. Byg selv eller vælg fra udvalget i butikken.',
      image: 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-711709435-1598139275648182-966955307337855336-n.jpg'
    },
    {
      slug: 'saesonvarer',
      name: 'Sæsonvarer',
      title: 'Sæsonvarer & Kastberg Is',
      desc: 'Sæsonens lækkerier til højtider samt cremet gourmet-is fra Kastberg (fra påske til efterårsferien).',
      image: ''
    }
  ];

  // Find den aktive kategori-info (standardiserer til chokolade hvis ingen matcher)
  const activeCategory = categories.find(c => c.slug === category) || categories[0];

  const [products, setProducts] = useState([]);
  const [frogs, setFrogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subFilter, setSubFilter] = useState('all');

  // Nulstil sub-filter ved ruteskift
  useEffect(() => {
    setSubFilter('all');
  }, [category]);

  // Opdater SEO
  useSEO(
    `${activeCategory.title} | Chokolenten ApS`,
    `${activeCategory.desc} Håndlavet i Hanstholm med fokus på kvalitet og smag.`
  );

  useEffect(() => {
    async function fetchCategoryProducts() {
      setLoading(true);
      // Hent alle produkter fra CMS'et
      const fetched = await getProducts();
      
      // Find alle chokoladefrøer til vores FrogCard
      const allFrogs = fetched.filter(product => {
        const title = (product.title?.da || product.title || '').toLowerCase();
        return title.includes('frø') || title.includes('froe');
      });
      setFrogs(allFrogs);
      
      // Klientside-kategorisering baseret på titel, beskrivelse og taksonomi-terms
      let filtered = fetched.filter(product => {
        const title = (product.title?.da || product.title || '').toLowerCase();
        const terms = product.terms?.['product-category'] || [];
        
        // 1. Chokolade
        if (activeCategory.slug === 'chokolade') {
          // Vi udelukker frøer fra den almindelige liste, da de vises samlet i FrogCard
          const isFrog = title.includes('frø') || title.includes('froe');
          if (isFrog) return false;

          const isChocolate = terms.includes('chokoladeplader') || 
                              terms.includes('chokoladeposer') || 
                              terms.includes('chokoladefroeer') || 
                              terms.includes('fyldte-chokolader') || 
                              terms.includes('toerret-mango-med-chokolade') ||
                              terms.includes('chokolade') ||
                              title.includes('plade') || title.includes('plader') ||
                              title.includes('pose') || title.includes('poser') ||
                              title.includes('mango') || title.includes('chokolade') ||
                              title.includes('stykker') || title.includes('stænger') ||
                              title.includes('blanding') || title.includes('harlekin') ||
                              title.includes('sommerfugle') || title.includes('ringene') ||
                              title.includes('pebermynte') || title.includes('citronfrø') ||
                              title.includes('dulce') || title.includes('jordbærfrø') ||
                              title.includes('hjerter');
          
          const isExcluded = title.includes('kage') || title.includes('tærte') || 
                             title.includes('fluff') || title.includes('flødebolle') || title.includes('floedebolle') ||
                             title.includes('nougat') || title.includes('cookie') || title.includes('kukie') ||
                             title.includes('æske') || title.includes('gaveæske') || title.includes('gavekurv') ||
                             title.includes('is');
          
          return isChocolate && !isExcluded;
        }
        
        // 2. Thy Kukies
        if (activeCategory.slug === 'thy-kukies') {
          return title.includes('cookie') || title.includes('kukie') || terms.includes('thy-kukies') || terms.includes('cookies');
        }
        
        // 3. Kager
        if (activeCategory.slug === 'kager') {
          // Udeluk fluff/flødeboller og nougat fra kager
          const isFluffOrNougat = title.includes('fluff') || title.includes('flødebolle') || title.includes('floedebolle') || title.includes('nougat');
          if (isFluffOrNougat) return false;

          return title.includes('kage') || title.includes('tærte') ||
                 terms.includes('kager') ||
                 (terms.includes('saesonvarer') && title.includes('kage'));
        }
        
        // 4. Gaveæsker & Gavekurve
        if (activeCategory.slug === 'gaveaesker-gavekurve') {
          return title.includes('æske') || title.includes('aeske') || title.includes('kurv') || 
                 terms.includes('gaveaesker') || terms.includes('gavekurve') || terms.includes('gaveaesker-gavekurve');
        }

        // 5. Sæsonvarer
        if (activeCategory.slug === 'saesonvarer') {
          return terms.includes('saesonvarer') || title.includes('is') || title.includes('sæson') || title.includes('kastberg');
        }
        
        return false;
      });

      // Apply sub-filter if active
      if (subFilter !== 'all') {
        filtered = filtered.filter(product => {
          const title = (product.title?.da || product.title || '').toLowerCase();
          
          if (activeCategory.slug === 'chokolade') {
            if (subFilter === 'froeer') {
              // Siden frøer nu er filtreret fra i starten, vil denne returnere ingenting, hvilket er perfekt, da vi kun vil vise FrogCard
              return false;
            }
            if (subFilter === 'fyldte') {
              const isSpecial = title.includes('plade') || title.includes('plader') || 
                                title.includes('pose') || title.includes('poser') ||
                                title.includes('mango');
              return !isSpecial;
            }
            if (subFilter === 'plader-poser') {
              return title.includes('plade') || title.includes('plader') || title.includes('pose') || title.includes('poser');
            }
            if (subFilter === 'mango') {
              return title.includes('mango');
            }
          }
          
          if (activeCategory.slug === 'kager') {
            if (subFilter === 'fluff') {
              // Siden fluff nu er filtreret fra i starten, vil denne returnere ingenting, hvilket er perfekt, da vi kun vil vise FluffCard
              return false;
            }
            if (subFilter === 'nougat') {
              return title.includes('nougat');
            }
            if (subFilter === 'kager') {
              return title.includes('kage') || title.includes('tærte');
            }
          }
          
          return true;
        });
      }

      setProducts(filtered);
      setLoading(false);
    }
    fetchCategoryProducts();
  }, [activeCategory.slug, subFilter]);

  return (
    <div className="pb-20">
      
      {/* Dynamic Hero Section */}
      <section className="relative py-24 bg-choc-dark text-cream-light overflow-hidden">
        {activeCategory.image && (
          <div className="absolute inset-0">
            <img
              src={activeCategory.image}
              alt={activeCategory.title}
              className="w-full h-full object-cover opacity-50 scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-choc-dark/70 via-choc-dark/30 to-transparent" />
          </div>
        )}

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center gap-4">
          <span className="text-xs font-sans uppercase tracking-[0.25em] text-berry-light font-bold">
            Vores sortiment
          </span>
          <h1 className="text-4xl sm:text-5xl font-serif font-bold text-cream-light tracking-wide">
            {activeCategory.title}
          </h1>
          <p className="max-w-2xl text-sm sm:text-base text-cream-light/80 leading-relaxed font-sans">
            {activeCategory.desc}
          </p>
        </div>
      </section>

      {/* Kategori Vælger (Tabs) */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-20">
        <div className="bg-cream-light rounded-2xl border border-choc-dark/10 shadow-md p-2 flex flex-wrap items-center justify-center gap-1 sm:gap-2">
          {categories.map((cat) => {
            const isSelected = activeCategory.slug === cat.slug;
            return (
              <Link
                key={cat.slug}
                to={`/produkter/${cat.slug}`}
                className={`px-4 py-2.5 rounded-xl font-sans text-xs sm:text-sm font-semibold transition-all cursor-pointer ${
                  isSelected
                    ? 'bg-berry-accent text-white shadow-sm'
                    : 'text-choc-dark/70 hover:text-choc-dark hover:bg-choc-dark/5'
                }`}
              >
                {cat.name}
              </Link>
            );
          })}
        </div>
      </section>

      {/* Sub-kategori Vælger (Sub-tabs) */}
      {(activeCategory.slug === 'chokolade' || activeCategory.slug === 'thy-kukies') && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
          <div className="flex flex-wrap items-center justify-center gap-2">
            {activeCategory.slug === 'chokolade' && [
              { id: 'all', label: 'Vis alle chokolader' },
              { id: 'fyldte', label: 'Fyldte chokolader' },
              { id: 'froeer', label: 'Chokoladefrøer' },
              { id: 'plader-poser', label: 'Plader & Poser' },
              { id: 'mango', label: 'Tørret mango' }
            ].map((sub) => (
              <button
                key={sub.id}
                onClick={() => setSubFilter(sub.id)}
                className={`px-3 py-1.5 rounded-full font-sans text-xs font-medium transition-all border cursor-pointer ${
                  subFilter === sub.id
                    ? 'bg-choc-dark text-cream-light border-choc-dark shadow-sm'
                    : 'bg-white text-choc-dark/70 border-choc-dark/10 hover:text-choc-dark hover:bg-choc-dark/5'
                }`}
              >
                {sub.label}
              </button>
            ))}

            {activeCategory.slug === 'thy-kukies' && [
              { id: 'all', label: 'Vis alle Kukies' },
              { id: 'klassiker', label: 'Klassiske Kukies' },
              { id: 'saeson', label: 'Sæson Kukies' }
            ].map((sub) => (
              <button
                key={sub.id}
                onClick={() => setSubFilter(sub.id)}
                className={`px-3 py-1.5 rounded-full font-sans text-xs font-medium transition-all border cursor-pointer ${
                  subFilter === sub.id
                    ? 'bg-choc-dark text-cream-light border-choc-dark shadow-sm'
                    : 'bg-white text-choc-dark/70 border-choc-dark/10 hover:text-choc-dark hover:bg-choc-dark/5'
                }`}
              >
                {sub.label}
              </button>
            ))}
          </div>
        </section>
      )}

      {/* Produkter Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        {loading ? (
          <div className="flex flex-col items-center justify-center py-20 gap-4">
            <div className="w-12 h-12 border-4 border-berry-accent border-t-transparent rounded-full animate-spin" />
            <p className="text-choc-dark/60 font-sans text-sm">Henter produkter...</p>
          </div>
        ) : activeCategory.slug === 'thy-kukies' ? (
          <div className="space-y-12">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 bg-cream-light/30 p-6 sm:p-8 rounded-2xl border border-choc-dark/5">
              <div className="max-w-3xl text-left">
                <h2 className="font-serif font-bold text-2xl sm:text-3xl text-choc-dark mb-3">Vores uimodståelige varianter</h2>
                <p className="text-choc-dark/70 font-sans text-sm sm:text-base leading-relaxed">
                  Vores store, lækre Thy Kukies bages friske hver mandag efter bestilling. Bliv inspireret af vores mange forskellige Kukies herunder, hvor du finder både vores klassikere og sæsonvarianter.
                </p>
              </div>
              <div className="flex shrink-0">
                <Link
                  to="/kontakt"
                  className="bg-berry-accent hover:bg-berry-accent/90 text-white font-sans text-sm font-semibold py-3 px-6 rounded-xl transition-colors shadow-sm hover:shadow cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="fa-solid fa-envelope" />
                  Kontakt os angående Kukies
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {cookieVariants
                .filter((cookie) => {
                  if (subFilter === 'klassiker') {
                    return cookie.tag !== 'Sæsonvariant';
                  }
                  if (subFilter === 'saeson') {
                    return cookie.tag === 'Sæsonvariant';
                  }
                  return true;
                })
                .map((cookie) => {
                  // De første 6 cookies (index 0-5 i det oprindelige cookieVariants array) samt alle sæsonvarianter vises med billede
                  const isImageCookie = cookieVariants.slice(0, 6).some(c => c.id === cookie.id) || cookie.tag === 'Sæsonvariant';
                  
                  if (isImageCookie) {
                    return <ProductCard key={cookie.id} product={cookie} />;
                  }

                  // Resten vises som rene tekstkort uden billede
                  return (
                    <div 
                      key={cookie.id} 
                      className="group bg-cream-light rounded-2xl border border-choc-dark/10 p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-berry-accent/30 flex flex-col h-full"
                    >
                      <div className="flex flex-col flex-grow">
                        {cookie.tag && (
                          <div className="mb-2">
                            <span className="text-xs font-sans font-bold uppercase tracking-wider text-berry-accent bg-berry-accent/10 px-2.5 py-1 rounded-full">
                              {cookie.tag}
                            </span>
                          </div>
                        )}
                        <h3 className="text-xl font-serif font-bold text-choc-dark mb-2 group-hover:text-berry-accent transition-colors">
                          {cookie.title}
                        </h3>
                        {cookie.description && (
                          <p className="text-sm text-choc-dark/70 leading-relaxed font-sans">
                            {cookie.description}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        ) : activeCategory.slug === 'chokolade' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Vis FrogCard hvis filteret er 'all' eller 'froeer' */}
            {(subFilter === 'all' || subFilter === 'froeer') && (
              <FrogCard frogs={frogs} />
            )}
            
            {/* Vis de resterende produkter */}
            {subFilter !== 'froeer' && products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}

            {/* Hvis filteret ikke er 'froeer' og der ikke er andre produkter */}
            {subFilter !== 'froeer' && products.length === 0 && (
              <div className="col-span-full text-center py-16 bg-cream-light rounded-2xl border border-choc-dark/10 p-8">
                <p className="text-choc-dark/60 font-sans italic">Der blev ikke fundet nogen produkter i denne kategori.</p>
              </div>
            )}
          </div>
        ) : activeCategory.slug === 'kager' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}

            {products.length === 0 && (
              <div className="col-span-full text-center py-16 bg-cream-light rounded-2xl border border-choc-dark/10 p-8">
                <p className="text-choc-dark/60 font-sans italic">Der blev ikke fundet nogen produkter i denne kategori.</p>
              </div>
            )}
          </div>
        ) : activeCategory.slug === 'gaveaesker-gavekurve' ? (
          <div className="w-full mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 items-center">
              <div className="md:col-span-6 flex flex-col gap-6">
                <span className="text-xs font-sans font-bold uppercase tracking-wider text-berry-accent bg-berry-accent/10 px-3 py-1 rounded-full self-start">
                  Til Private & Erhverv
                </span>
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-bold text-choc-dark leading-tight">
                  Gaveæsker & Gavekurve
                </h3>
                <p className="text-base sm:text-lg text-choc-dark/80 leading-relaxed font-sans">
                  Vi laver gaveæsker og gavekurve til private og erhverv i alle størrelser og sammensætninger. Du kan enten bygge selv eller vælge blandt vores udvalg i butikken.
                </p>
                <p className="text-sm text-choc-dark/60 font-sans">
                  Kig forbi vores hyggelige butik i Hanstholm, eller kontakt os for at høre mere om mulighederne for at sammensætte den perfekte gave til firmaer, personalegaver, kundegaver eller private anledninger.
                </p>
                <div className="flex flex-wrap gap-4 mt-2">
                  <Link
                    to="/kontakt"
                    className="bg-berry-accent hover:bg-berry-accent/90 text-white font-sans text-sm font-semibold py-3 px-6 rounded-xl transition-colors shadow-sm hover:shadow cursor-pointer flex items-center gap-2"
                  >
                    <i className="fa-solid fa-envelope" />
                    Kontakt os
                  </Link>
                  <Link
                    to="/kontakt"
                    className="bg-choc-dark hover:bg-choc-dark/90 text-cream-light font-sans text-sm font-semibold py-3 px-6 rounded-xl transition-colors shadow-sm hover:shadow cursor-pointer flex items-center gap-2"
                  >
                    <i className="fa-solid fa-map-marker-alt" />
                    Find butik
                  </Link>
                </div>
              </div>
              <div className="md:col-span-6">
                <div className="relative aspect-square rounded-2xl overflow-hidden border border-choc-dark/10 shadow-md group">
                  <img
                    alt="Gaveæsker og gavekurve hos Chokolenten"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-117-693556591-1580201547441955-3363968098443594962-n.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
        ) : products.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16 bg-cream-light rounded-2xl border border-choc-dark/10 p-8">
            <p className="text-choc-dark/60 font-sans italic">Der blev ikke fundet nogen produkter i denne kategori.</p>
          </div>
        )}
      </section>

      {/* Særlig information for Thy Kukies */}
      {activeCategory.slug === 'thy-kukies' && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            
            {/* Godt at vide */}
            <div className="bg-cream-light border border-choc-dark/10 rounded-2xl p-6 sm:p-8 shadow-sm flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-berry-accent/10 flex items-center justify-center text-berry-accent">
                  <i className="fa-solid fa-circle-question text-lg" />
                </div>
                <h4 className="font-serif font-bold text-lg text-choc-dark">Godt at vide</h4>
              </div>
              <ul className="text-sm text-choc-dark/80 font-sans flex flex-col gap-3">
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-wand-magic-sparkles text-berry-accent mt-1" />
                  <span>Håndlavede produkter varierer i størrelse og udseende.</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-arrows-left-right text-berry-accent mt-1" />
                  <span>Kan være både sprøde og bløde.</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-palette text-berry-accent mt-1" />
                  <span>Lys/grå farve kan komme naturligt fra fyldet.</span>
                </li>
                <li className="flex items-start gap-2.5 text-amber-800">
                  <i className="fa-solid fa-triangle-exclamation text-amber-600 mt-1" />
                  <span>Chokoladeknap-varianten er mest udsat for transportskader og sendes på eget ansvar.</span>
                </li>
              </ul>
            </div>

            {/* Opbevaring */}
            <div className="bg-cream-light border border-choc-dark/10 rounded-2xl p-6 sm:p-8 shadow-sm flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-berry-accent/10 flex items-center justify-center text-berry-accent">
                  <i className="fa-solid fa-temperature-half text-lg" />
                </div>
                <h4 className="font-serif font-bold text-lg text-choc-dark">Opbevaring</h4>
              </div>
              <ul className="text-sm text-choc-dark/80 font-sans flex flex-col gap-3">
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-house text-berry-accent mt-1" />
                  <span>Ved stuetemperatur eller i chokoladekøler.</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-box-tissue text-berry-accent mt-1" />
                  <span>Kan pakkes i cellofanposer.</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="fa-solid fa-droplet-slash text-berry-accent mt-1" />
                  <span>Opbevares tørt og ikke for varmt.</span>
                </li>
              </ul>
            </div>

          </div>
        </section>
      )}

      {/* Standard Kategori Tekst & CTA */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        <div className="text-center py-16 bg-cream-light rounded-2xl border border-choc-dark/10 p-8 sm:p-12 w-full mx-auto flex flex-col gap-6 shadow-sm">
          <h3 className="font-serif font-bold text-2xl sm:text-3xl text-choc-dark">
            Vores udvalg af {activeCategory.name}
          </h3>
          <p className="text-sm sm:text-base text-choc-dark/70 font-sans leading-relaxed">
            Vi bager og laver hele tiden nye, friske lækkerier i denne kategori. Da vores sortiment varierer dagligt efter sæson og råvarer, kan du altid ringe, skrive eller kigge forbi butikken for at høre, hvad vi har i montren i dag.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-4">
            <Link
              to="/kontakt"
              className="bg-berry-accent hover:bg-berry-accent/90 text-white font-sans font-semibold px-6 py-3 rounded-xl text-sm transition-colors cursor-pointer shadow-sm"
            >
              Kontakt os
            </Link>
            <a
              href="https://www.instagram.com/chokolenten/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-transparent hover:bg-choc-dark/5 text-choc-dark border border-choc-dark/20 font-sans font-semibold px-6 py-3 rounded-xl text-sm transition-colors cursor-pointer"
            >
              Følg med på Instagram
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}
